// src/hooks/useRaveAlert.js
import { useState, useEffect, useCallback } from 'react';
import { fetchRaveData, processRaveData } from '../services/raveAlertService';
// for testing whether it is working
import { fetchRaveDataTest } from '../services/raveAlertService.test';

/**
 * Managing Rave alert state
 * Handles fetching, processing, and auto-updating alert data
 */
export function useRaveAlert() {
  const [alertData, setAlertData] = useState({
    isActive: false,
    title: '',
    description: '',
    rawData: null
  });
  
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to fetch and update alert data
  const updateAlertData = useCallback(async () => {
    try {
      setError(null); 
      const raveData = await fetchRaveData();
      const processedData = processRaveData(raveData);
      setAlertData(processedData);
    } catch (err) {
      console.error('Error updating alert data:', err);
      setError(err);
      setAlertData({
        isActive: false,
        title: '',
        description: '',
        rawData: null
      });
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Set up the polling interval and initial fetch
  useEffect(() => {
    updateAlertData();

    // Set up interval to check every 60 seconds
    const intervalId = setInterval(updateAlertData, 60000);

    // Cleanup function: clear interval when component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, [updateAlertData]); 

  return {
    alertData,
    isLoading,
    error,
    refetchAlert: updateAlertData 
  };
}